export const countries = {
  unitedStates: { value: 'United States', text: 'USA' },
  afghanistan: { value: 'Afghanistan', text: 'Afghanistan' },
  akrotiriSovereignBaseArea: {
    value: 'Akrotiri Sovereign Base Area',
    text: 'Akrotiri Sovereign Base Area',
  },
  albania: { value: 'Albania', text: 'Albania' },
  algeria: { value: 'Algeria', text: 'Algeria' },
  andorra: { value: 'Andorra', text: 'Andorra' },
  angola: { value: 'Angola', text: 'Angola' },
  anguilla: { value: 'Anguilla', text: 'Anguilla' },
  antarctica: { value: 'Antarctica', text: 'Antarctica' },
  antiguaAndBarbuda: {
    value: 'Antigua and Barbuda',
    text: 'Antigua and Barbuda',
  },
  argentina: { value: 'Argentina', text: 'Argentina' },
  armenia: { value: 'Armenia', text: 'Armenia' },
  aruba: { value: 'Aruba', text: 'Aruba' },
  ashmoreAndCartierIslands: {
    value: 'Ashmore and Cartier Islands',
    text: 'Ashmore and Cartier Islands',
  },
  australia: { value: 'Australia', text: 'Australia' },
  austria: { value: 'Austria', text: 'Austria' },
  azerbaijan: { value: 'Azerbaijan', text: 'Azerbaijan' },
  bahamas: { value: 'Bahamas, The', text: 'Bahamas, The' },
  bahrain: { value: 'Bahrain', text: 'Bahrain' },
  bangladesh: { value: 'Bangladesh', text: 'Bangladesh' },
  barbados: { value: 'Barbados', text: 'Barbados' },
  bassasDaIndia: { value: 'Bassas da India', text: 'Bassas da India' },
  belarus: { value: 'Belarus', text: 'Belarus' },
  belgium: { value: 'Belgium', text: 'Belgium' },
  belize: { value: 'Belize', text: 'Belize' },
  benin: { value: 'Benin', text: 'Benin' },
  bermuda: { value: 'Bermuda', text: 'Bermuda' },
  bhutan: { value: 'Bhutan', text: 'Bhutan' },
  bolivia: { value: 'Bolivia', text: 'Bolivia' },
  bosniaAndHerzegovina: {
    value: 'Bosnia and Herzegovina',
    text: 'Bosnia and Herzegovina',
  },
  botswana: { value: 'Botswana', text: 'Botswana' },
  bouvetIsland: { value: 'Bouvet Island', text: 'Bouvet Island' },
  brazil: { value: 'Brazil', text: 'Brazil' },
  britishIndianOceanTerritory: {
    value: 'British Indian Ocean Territory',
    text: 'British Indian Ocean Territory',
  },
  britishVirginIslands: {
    value: 'British Virgin Islands',
    text: 'British Virgin Islands',
  },
  brunei: { value: 'Brunei', text: 'Brunei' },
  bulgaria: { value: 'Bulgaria', text: 'Bulgaria' },
  burkinaFaso: { value: 'Burkina Faso', text: 'Burkina Faso' },
  burma: { value: 'Burma', text: 'Burma' },
  burundi: { value: 'Burundi', text: 'Burundi' },
  cambodia: { value: 'Cambodia', text: 'Cambodia' },
  cameroon: { value: 'Cameroon', text: 'Cameroon' },
  canada: { value: 'Canada', text: 'Canada' },
  capeVerde: { value: 'Cape Verde', text: 'Cape Verde' },
  caymanIslands: { value: 'Cayman Islands', text: 'Cayman Islands' },
  centralAfricanRepublic: {
    value: 'Central African Republic',
    text: 'Central African Republic',
  },
  chad: { value: 'Chad', text: 'Chad' },
  chile: { value: 'Chile', text: 'Chile' },
  china: { value: 'China', text: 'China' },
  christmasIsland: { value: 'Christmas Island', text: 'Christmas Island' },
  clippertonIsland: { value: 'Clipperton Island', text: 'Clipperton Island' },
  cocosKeelingIslands: {
    value: 'Cocos Keeling Islands',
    text: 'Cocos Keeling Islands',
  },
  colombia: { value: 'Colombia', text: 'Colombia' },
  comoros: { value: 'Comoros', text: 'Comoros' },
  congo: { value: 'Congo', text: 'Congo' },
  congoDemocraticRepublic: {
    value: 'Congo, Democratic Republic of the',
    text: 'Congo, Democratic Republic of the',
  },
  cookIslands: { value: 'Cook Islands', text: 'Cook Islands' },
  coralSeaIslands: { value: 'Coral Sea Islands', text: 'Coral Sea Islands' },
  costaRica: { value: 'Costa Rica', text: 'Costa Rica' },
  coteIvoire: { value: "Cote d'Ivoire", text: "Cote d'Ivoire" },
  croatia: { value: 'Croatia', text: 'Croatia' },
  cuba: { value: 'Cuba', text: 'Cuba' },
  cyprus: { value: 'Cyprus', text: 'Cyprus' },
  czechRepublic: { value: 'Czech Republic', text: 'Czech Republic' },
  denmark: { value: 'Denmark', text: 'Denmark' },
  dhekeliaSovereignBaseArea: {
    value: 'Dhekelia Sovereign Base Area',
    text: 'Dhekelia Sovereign Base Area',
  },
  djibouti: { value: 'Djibouti', text: 'Djibouti' },
  dominica: { value: 'Dominica', text: 'Dominica' },
  dominicanRepublic: {
    value: 'Dominican Republic',
    text: 'Dominican Republic',
  },
  eastTimor: { value: 'East Timor', text: 'East Timor' },
  ecuador: { value: 'Ecuador', text: 'Ecuador' },
  egypt: { value: 'Egypt', text: 'Egypt' },
  elSalvador: { value: 'El Salvador', text: 'El Salvador' },
  equatorialGuinea: { value: 'Equatorial Guinea', text: 'Equatorial Guinea' },
  eritrea: { value: 'Eritrea', text: 'Eritrea' },
  estonia: { value: 'Estonia', text: 'Estonia' },
  ethiopia: { value: 'Ethiopia', text: 'Ethiopia' },
  etorofuHabomaiKunashiriAndShikotanIslands: {
    value: 'Etorofu, Habomai, Kunashiri And Shikotan Islands',
    text: 'Etorofu, Habomai, Kunashiri And Shikotan Islands',
  },
  europaIsland: { value: 'Europa Island', text: 'Europa Island' },
  falklandIslandsIslasMalvinas: {
    value: 'Falkland Islands Islas Malvinas',
    text: 'Falkland Islands Islas Malvinas',
  },
  faroeIslands: { value: 'Faroe Islands', text: 'Faroe Islands' },
  fiji: { value: 'Fiji', text: 'Fiji' },
  finland: { value: 'Finland', text: 'Finland' },
  france: { value: 'France', text: 'France' },
  frenchGuiana: { value: 'French Guiana', text: 'French Guiana' },
  frenchPolynesia: { value: 'French Polynesia', text: 'French Polynesia' },
  frenchSouthernAndAntarcticLands: {
    value: 'French Southern and Antarctic Lands',
    text: 'French Southern and Antarctic Lands',
  },
  gabon: { value: 'Gabon', text: 'Gabon' },
  gambia: { value: 'Gambia, The', text: 'Gambia, The' },
  gazaStrip: { value: 'Gaza Strip', text: 'Gaza Strip' },
  georgia: { value: 'Georgia', text: 'Georgia' },
  germany: { value: 'Germany', text: 'Germany' },
  ghana: { value: 'Ghana', text: 'Ghana' },
  gibraltar: { value: 'Gibraltar', text: 'Gibraltar' },
  gloriosoIslands: { value: 'Glorioso Islands', text: 'Glorioso Islands' },
  greece: { value: 'Greece', text: 'Greece' },
  greenland: { value: 'Greenland', text: 'Greenland' },
  grenada: { value: 'Grenada', text: 'Grenada' },
  guadeloupe: { value: 'Guadeloupe', text: 'Guadeloupe' },
  guatemala: { value: 'Guatemala', text: 'Guatemala' },
  guernsey: { value: 'Guernsey', text: 'Guernsey' },
  guinea: { value: 'Guinea', text: 'Guinea' },
  guineaBissau: { value: 'Guinea-Bissau', text: 'Guinea-Bissau' },
  guyana: { value: 'Guyana', text: 'Guyana' },
  haiti: { value: 'Haiti', text: 'Haiti' },
  heardIslandAndMcDonaldIslands: {
    value: 'Heard Island and McDonald Islands',
    text: 'Heard Island and McDonald Islands',
  },
  honduras: { value: 'Honduras', text: 'Honduras' },
  hongKong: { value: 'Hong Kong', text: 'Hong Kong' },
  hungary: { value: 'Hungary', text: 'Hungary' },
  iceland: { value: 'Iceland', text: 'Iceland' },
  india: { value: 'India', text: 'India' },
  indonesia: { value: 'Indonesia', text: 'Indonesia' },
  iran: { value: 'Iran', text: 'Iran' },
  iraq: { value: 'Iraq', text: 'Iraq' },
  ireland: { value: 'Ireland', text: 'Ireland' },
  isleOfMan: { value: 'Isle of Man', text: 'Isle of Man' },
  israel: { value: 'Israel', text: 'Israel' },
  italy: { value: 'Italy', text: 'Italy' },
  jamaica: { value: 'Jamaica', text: 'Jamaica' },
  janMayen: { value: 'Jan Mayen', text: 'Jan Mayen' },
  japan: { value: 'Japan', text: 'Japan' },
  jersey: { value: 'Jersey', text: 'Jersey' },
  jordan: { value: 'Jordan', text: 'Jordan' },
  juanDeNovaIsland: {
    value: 'Juan de Nova Island',
    text: 'Juan de Nova Island',
  },
  kazakhstan: { value: 'Kazakhstan', text: 'Kazakhstan' },
  kenya: { value: 'Kenya', text: 'Kenya' },
  kiribati: { value: 'Kiribati', text: 'Kiribati' },
  kosovo: { value: 'Kosovo', text: 'Kosovo' },
  kuwait: { value: 'Kuwait', text: 'Kuwait' },
  kyrgyzstan: { value: 'Kyrgyzstan', text: 'Kyrgyzstan' },
  laos: { value: 'Laos', text: 'Laos' },
  latvia: { value: 'Latvia', text: 'Latvia' },
  lebanon: { value: 'Lebanon', text: 'Lebanon' },
  lesotho: { value: 'Lesotho', text: 'Lesotho' },
  liberia: { value: 'Liberia', text: 'Liberia' },
  libya: { value: 'Libya', text: 'Libya' },
  liechtenstein: { value: 'Liechtenstein', text: 'Liechtenstein' },
  lithuania: { value: 'Lithuania', text: 'Lithuania' },
  luxembourg: { value: 'Luxembourg', text: 'Luxembourg' },
  macau: { value: 'Macau', text: 'Macau' },
  macedonia: { value: 'Macedonia', text: 'Macedonia' },
  madagascar: { value: 'Madagascar', text: 'Madagascar' },
  malawi: { value: 'Malawi', text: 'Malawi' },
  malaysia: { value: 'Malaysia', text: 'Malaysia' },
  maldives: { value: 'Maldives', text: 'Maldives' },
  mali: { value: 'Mali', text: 'Mali' },
  malta: { value: 'Malta', text: 'Malta' },
  marshallIslands: { value: 'Marshall Islands', text: 'Marshall Islands' },
  martinique: { value: 'Martinique', text: 'Martinique' },
  mauritania: { value: 'Mauritania', text: 'Mauritania' },
  mauritius: { value: 'Mauritius', text: 'Mauritius' },
  mayotte: { value: 'Mayotte', text: 'Mayotte' },
  mexico: { value: 'Mexico', text: 'Mexico' },
  micronesiaFederatedStates: {
    value: 'Micronesia, Federated States of',
    text: 'Micronesia, Federated States of',
  },
  moldova: { value: 'Moldova', text: 'Moldova' },
  monaco: { value: 'Monaco', text: 'Monaco' },
  mongolia: { value: 'Mongolia', text: 'Mongolia' },
  montenegro: { value: 'Montenegro', text: 'Montenegro' },
  montserrat: { value: 'Montserrat', text: 'Montserrat' },
  morocco: { value: 'Morocco', text: 'Morocco' },
  mozambique: { value: 'Mozambique', text: 'Mozambique' },
  namibia: { value: 'Namibia', text: 'Namibia' },
  nauru: { value: 'Nauru', text: 'Nauru' },
  nepal: { value: 'Nepal', text: 'Nepal' },
  netherlands: { value: 'Netherlands', text: 'Netherlands' },
  netherlandsAntilles: {
    value: 'Netherlands Antilles',
    text: 'Netherlands Antilles',
  },
  newCaledonia: { value: 'New Caledonia', text: 'New Caledonia' },
  newZealand: { value: 'New Zealand', text: 'New Zealand' },
  nicaragua: { value: 'Nicaragua', text: 'Nicaragua' },
  niger: { value: 'Niger', text: 'Niger' },
  nigeria: { value: 'Nigeria', text: 'Nigeria' },
  niue: { value: 'Niue', text: 'Niue' },
  norfolkIsland: { value: 'Norfolk Island', text: 'Norfolk Island' },
  northKorea: { value: 'North Korea', text: 'North Korea' },
  norway: { value: 'Norway', text: 'Norway' },
  oman: { value: 'Oman', text: 'Oman' },
  pakistan: { value: 'Pakistan', text: 'Pakistan' },
  palau: { value: 'Palau', text: 'Palau' },
  panama: { value: 'Panama', text: 'Panama' },
  papuaNewGuinea: { value: 'Papua New Guinea', text: 'Papua New Guinea' },
  paracelIslands: { value: 'Paracel Islands', text: 'Paracel Islands' },
  paraguay: { value: 'Paraguay', text: 'Paraguay' },
  peru: { value: 'Peru', text: 'Peru' },
  philippines: { value: 'Philippines', text: 'Philippines' },
  pitcairnIslands: { value: 'Pitcairn Islands', text: 'Pitcairn Islands' },
  poland: { value: 'Poland', text: 'Poland' },
  portugal: { value: 'Portugal', text: 'Portugal' },
  qatar: { value: 'Qatar', text: 'Qatar' },
  reunion: { value: 'Reunion', text: 'Reunion' },
  romania: { value: 'Romania', text: 'Romania' },
  russia: { value: 'Russia', text: 'Russia' },
  rwanda: { value: 'Rwanda', text: 'Rwanda' },
  saintBarthelemy: { value: 'Saint Barthelemy', text: 'Saint Barthelemy' },
  saintHelena: { value: 'Saint Helena', text: 'Saint Helena' },
  saintKittsAndNevis: {
    value: 'Saint Kitts and Nevis',
    text: 'Saint Kitts and Nevis',
  },
  saintLucia: { value: 'Saint Lucia', text: 'Saint Lucia' },
  saintMartin: { value: 'Saint Martin', text: 'Saint Martin' },
  saintPierreAndMiquelon: {
    value: 'Saint Pierre and Miquelon',
    text: 'Saint Pierre and Miquelon',
  },
  saintVincentAndTheGrenadines: {
    value: 'Saint Vincent and the Grenadines',
    text: 'Saint Vincent and the Grenadines',
  },
  samoa: { value: 'Samoa', text: 'Samoa' },
  sanMarino: { value: 'San Marino', text: 'San Marino' },
  saoTomeAndPrincipe: {
    value: 'Sao Tome and Principe',
    text: 'Sao Tome and Principe',
  },
  saudiArabia: { value: 'Saudi Arabia', text: 'Saudi Arabia' },
  senegal: { value: 'Senegal', text: 'Senegal' },
  serbia: { value: 'Serbia', text: 'Serbia' },
  seychelles: { value: 'Seychelles', text: 'Seychelles' },
  sierraLeone: { value: 'Sierra Leone', text: 'Sierra Leone' },
  singapore: { value: 'Singapore', text: 'Singapore' },
  slovakia: { value: 'Slovakia', text: 'Slovakia' },
  slovenia: { value: 'Slovenia', text: 'Slovenia' },
  solomonIslands: { value: 'Solomon Islands', text: 'Solomon Islands' },
  somalia: { value: 'Somalia', text: 'Somalia' },
  southAfrica: { value: 'South Africa', text: 'South Africa' },
  southGeorgiaAndTheSouthSandwichIslands: {
    value: 'South Georgia and the South Sandwich Islands',
    text: 'South Georgia and the South Sandwich Islands',
  },
  southKorea: { value: 'South Korea', text: 'South Korea' },
  southSudan: { value: 'South Sudan', text: 'South Sudan' },
  spain: { value: 'Spain', text: 'Spain' },
  spratlyIslands: { value: 'Spratly Islands', text: 'Spratly Islands' },
  sriLanka: { value: 'Sri Lanka', text: 'Sri Lanka' },
  sudan: { value: 'Sudan', text: 'Sudan' },
  suriname: { value: 'Suriname', text: 'Suriname' },
  svalbard: { value: 'Svalbard', text: 'Svalbard' },
  swaziland: { value: 'Swaziland', text: 'Swaziland' },
  sweden: { value: 'Sweden', text: 'Sweden' },
  switzerland: { value: 'Switzerland', text: 'Switzerland' },
  syria: { value: 'Syria', text: 'Syria' },
  taiwan: { value: 'Taiwan', text: 'Taiwan' },
  tajikistan: { value: 'Tajikistan', text: 'Tajikistan' },
  tanzania: { value: 'Tanzania', text: 'Tanzania' },
  thailand: { value: 'Thailand', text: 'Thailand' },
  togo: { value: 'Togo', text: 'Togo' },
  tokelau: { value: 'Tokelau', text: 'Tokelau' },
  tonga: { value: 'Tonga', text: 'Tonga' },
  trinidadAndTobago: {
    value: 'Trinidad and Tobago',
    text: 'Trinidad and Tobago',
  },
  tromelinIsland: { value: 'Tromelin Island', text: 'Tromelin Island' },
  tunisia: { value: 'Tunisia', text: 'Tunisia' },
  turkey: { value: 'Turkey', text: 'Turkey' },
  turkmenistan: { value: 'Turkmenistan', text: 'Turkmenistan' },
  turksAndCaicosIslands: {
    value: 'Turks and Caicos Islands',
    text: 'Turks and Caicos Islands',
  },
  tuvalu: { value: 'Tuvalu', text: 'Tuvalu' },
  uganda: { value: 'Uganda', text: 'Uganda' },
  ukraine: { value: 'Ukraine', text: 'Ukraine' },
  unitedArabEmirates: { value: 'United Arab Emirates', text: 'UAE' },
  unitedKingdom: { value: 'United Kingdom', text: 'UK' },
  uruguay: { value: 'Uruguay', text: 'Uruguay' },
  uzbekistan: { value: 'Uzbekistan', text: 'Uzbekistan' },
  vanuatu: { value: 'Vanuatu', text: 'Vanuatu' },
  vaticanCity: { value: 'Vatican City', text: 'Vatican City' },
  venezuela: { value: 'Venezuela', text: 'Venezuela' },
  vietnam: { value: 'Vietnam', text: 'Vietnam' },
  wallisAndFutuna: { value: 'Wallis and Futuna', text: 'Wallis and Futuna' },
  westBank: { value: 'West Bank', text: 'West Bank' },
  westernSahara: { value: 'Western Sahara', text: 'Western Sahara' },
  yemen: { value: 'Yemen', text: 'Yemen' },
  zambia: { value: 'Zambia', text: 'Zambia' },
  zimbabwe: { value: 'Zimbabwe', text: 'Zimbabwe' },
};
